import { BaseViewChangeSate } from "../BaseViewChangeState"; 
import { DropdownProps } from "../DropdownProps"; 
import { EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY, ExchangeRateRefDateMappingEntity } from "domain/entity/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingEntity";
export interface ExchangeRateRefDateMappingDropdownOptions { 
    customerCodeDropdownOptions: DropdownProps[],
} 
export interface MasterChangeState extends BaseViewChangeSate { 
    editingEntity: ExchangeRateRefDateMappingEntity, 
} 
export interface ExchangeRateRefDateMappingModel { 
    isLoading: boolean, 
    tableData: ExchangeRateRefDateMappingEntity[], 
    currentSelectedRow: ExchangeRateRefDateMappingEntity, 
    selectedRows: ExchangeRateRefDateMappingEntity[], 
    dynamicOptions: ExchangeRateRefDateMappingDropdownOptions,
    masterState: MasterChangeState, 
    isBackMaster: boolean, 
    isShowEditPanel: boolean,
} 
export const EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_MODEL: ExchangeRateRefDateMappingModel = { 
    isLoading: false, 
    tableData: [], 
    currentSelectedRow: { ...EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY }, 
    selectedRows: [], 
    dynamicOptions: { 
        customerCodeDropdownOptions: [],
    }, 
    masterState: { 
        isSliderOpen: false, 
        isTabularDataActive: false, 
        isAdd: false, 
        isRead: false, 
        isEditable: false, 
        isSaveClicked: false, 
        lastEditRowId: "", 
        isSelected: false, 
        slider: { 
            isAdd: false, 
            isRead: false, 
            isEditable: false 
        }, 
        editingEntity: EMPTY_EXCHANGE_RATE_REF_DATE_MAPPING_ENTITY, 
    }, 
    isBackMaster: false, 
    isShowEditPanel: false,
} 
